import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const [search] = useSearchParams();
  const next = search.get("next") || "/dashboard";

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await login(form.email, form.password);
    setLoading(false);
    if (r.ok) nav(next);
    else setErr(r.error);
  };

  return (
    <div className="container-jcc py-24 max-w-md" data-testid="page-login">
      <h1 className="font-display text-4xl font-bold">Welcome back.</h1>
      <p className="mt-2 text-ink-muted">Log in to your JCC account.</p>
      <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="login-form">
        <div>
          <label className="block text-sm font-medium mb-1.5">Email</label>
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="login-email" className="w-full rounded-xl border border-slate-200 px-4 py-3 focus:border-teal focus:ring-1 focus:ring-teal outline-none" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">Password</label>
          <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="login-password" className="w-full rounded-xl border border-slate-200 px-4 py-3 focus:border-teal focus:ring-1 focus:ring-teal outline-none" />
          <div className="mt-1.5 text-right">
            <a
              href="https://members.justcarecommunity.com/restore-password"
              className="text-sm text-ink-muted hover:text-teal transition-colors"
              data-testid="login-forgot-password"
            >
              Forgot password?
            </a>
          </div>
        </div>
        {err && <p className="text-sm text-red-600" data-testid="login-error">{err}</p>}
        <button className="btn-teal w-full" disabled={loading} data-testid="login-submit">{loading ? "Logging in…" : "Log in"}</button>
      </form>
    </div>
  );
}
